import { computed } from 'vue'
import { CSS_CLASSES } from '../constants/dropdown-button-constants.js'

/**
 * Styling and CSS classes for DropDown Button component
 * Giữ nguyên logic class từ file gốc
 */
export function useDropDownButtonStyles(props, componentState) {
  
  // Container classes - giữ nguyên logic từ template gốc
  const containerClasses = computed(() => [
    CSS_CLASSES.DROP_DOWN_BUTTON,
    CSS_CLASSES.FLEX_CENTER,
    componentState.shouldShowParentBorder.value ? CSS_CLASSES.BORDER_PARENT : '',
    componentState.isDisabled.value ? CSS_CLASSES.DISABLED : '',
    componentState.isFooterHelpful.value ? CSS_CLASSES.FOOTER_HELPFUL : '',
  ])
  
  // Menu wrapper classes
  const menuWrapperClasses = computed(() => [
    CSS_CLASSES.WIDGET_MORE_CONTAINER,
    CSS_CLASSES.WIDGET_BTN,
    props.type
  ])
  
  // Primary button classes - giữ nguyên logic từ template gốc
  const primaryButtonClasses = computed(() => [
    CSS_CLASSES.BTN,
    CSS_CLASSES.FLEX_ROW,
    CSS_CLASSES.PRIMARY_BUTTON,
    props.type,
    props.classCustom,
    componentState.shouldShowBorder.value ? '' : CSS_CLASSES.BORDER_NONE
  ])
  
  // Widget more button classes - giữ nguyên logic từ template gốc
  const widgetMoreClasses = computed(() => [
    CSS_CLASSES.WIDGET_MORE,
    props.type,
    props.classCustom,
    componentState.shouldShowBorder.value ? '' : CSS_CLASSES.BORDER_NONE,
    componentState.isFooterHelpful.value ? CSS_CLASSES.FOOTER : ''
  ])
  
  // Left icon classes - giữ nguyên logic từ template gốc
  const leftIconClasses = computed(() => [
    'icon24', 'icon', 'left',
    props.leftIcon
  ])
  
  // Text classes - giữ nguyên logic từ template gốc
  const textClasses = computed(() => [
    CSS_CLASSES.TEXT,
    {
      'pl-0': componentState.hasLeftIcon.value,
      'pr-0': componentState.hasRightIcon.value
    }
  ])
  
  // Show/hide conditions
  const showLeftIcon = computed(() => componentState.hasLeftIcon.value)
  const showText = computed(() => componentState.hasText.value)
  
  return {
    // Container
    containerClasses,
    
    // Menu wrapper
    menuWrapperClasses,
    
    // Buttons
    primaryButtonClasses,
    widgetMoreClasses,
    
    // Icon and text
    leftIconClasses,
    textClasses,
    
    // Show/hide
    showLeftIcon,
    showText
  }
}
